export enum BankAccountStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  NOTAPPROVED = 'not-approved',
  INACTIVE = 'in-active',
}

export interface BankAccountType {
  bankName: string;
  accountType: string;
  holderName: string;
  accountNumber: string;
  routingNumber: string;
}

export enum AccountType {
  CHECKING_OR_SAVING = 'checking_or_saving',
  CREDIT_CARD = 'credit_card',
}

export enum CreditCardEnum {
  CREDIT_CARD = 'credit card',
}

export enum BankAccountTYpesEnum {
  CHECKING = 'checking',
}

export interface DecryptedBank {
  bankId: number;
  bankName: string;
  mask: string;
  type: string;
  accountName: string;
}
